import getApiClient from '@/plugins/api-client'

export default {
    loadTemplates() {
        const self = this,
            api = getApiClient(self.$store)

        api.get('message_templates')
            .then(result => {
                self.templates = result.data['hydra:member']
            })
            .catch(error => {
                console.log(error)
            })
    },
    goToEditTemplate(templateId) {
        this.$router.push({
            name: 'Editar Template',
            params: {
                id: templateId
            }
        })
    }
}
